
import backButtonOutlined from "../common/back-button-outlined.vue";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: { backButtonOutlined },
  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    currentStepItem: {
      type: Object,
      default: {}
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isValid: false
    };
  },
  mounted() {
    this.chackValid();
  },
  computed: {
    ...mapGetters("menu", ["getMenuUploadList"]),
    ...mapState("menu", ["menuUploadRawData"])
  },
  watch: {
    getMenuUploadList: {
      handler(val) {
        this.handleCheckValid();
      },
      deep: true
    },
    menuUploadRawData() {
      this.handleCheckValid();
    },
    currentStep() {
      this.handleCheckValid();
    },
    currentStepItem() {
      this.handleCheckValid();
    }
  },
  methods: {
    handleCheckValid() {
      this.$nextTick(() => {
        this.isValid = this.chackValid();
      });
    },
    chackValid() {
      switch (this.currentStepItem.id) {
        case "upload-file":
          return !!this.menuUploadRawData?.length;
        case "mapping-step":
          return this.currentStepItem.attributes
            .filter((el) => el.required)
            .every((item) => !!this.getMenuUploadList?.[0]?.[item.value]);
        case "assign-platform":
          return this.getMenuUploadList.every(
            (el) => el[this.currentStepItem.property]?.length
          );
        case "dish-type":
        case "set-category":
          return this.getMenuUploadList.every(
            (el) => !!el[this.currentStepItem.property]
          );
        default:
          return true;
      }
    }
  }
};
